export default __webpack_public_path__ + "static/media/bumper_2.fa5016dc.jpg";